import { CreateSignalOptions, inject, Injectable, InjectionToken, signal, WritableSignal } from '@angular/core';

import { Utilities } from '@tess-core/shared';

// https://github.com/jsanta/ng16-signals-tests/blob/develop/src/app/services/global-signal.service.ts
@Injectable({ providedIn: 'root' })
export class TessSignalBusService {
  readonly #signalMap = new Map<string, WritableSignal<unknown>>();
  #nextId = 1;

  destroy(key: string): boolean {
    return this.#signalMap.delete(key);
  }

  getNewId(): string {
    return `tess-global-signal-service-${this.#nextId++}`;
  }

  get<T>(key: string, defaultValue: T | undefined = undefined, options?: CreateSignalOptions<T>): WritableSignal<T> {
    if (!this.#signalMap.has(key)) {
      this.#signalMap.set(key, signal<T | undefined>(defaultValue, options));
    }

    return this.#signalMap.get(key) as WritableSignal<T>;
  }

  set<T>(key: string, value: T, options?: CreateSignalOptions<T>): void {
    this.get<T>(key, undefined, options).set(value);
  }

  update<T>(key: string, newValue: T): void {
    this.get<T>(key).update(_ => Utilities.deepCopy(newValue));
  }
}

export const GLOBAL_SIGNAL_SERVICE = new InjectionToken<TessSignalBusService>('GLOBAL_SIGNAL_SERVICE', {
  providedIn: 'root',
  factory: (): TessSignalBusService => inject(TessSignalBusService),
});
